module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/Rupay.c316b8e3.png";